import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import styles from './BillingConfigs.module.scss'

import { EnterpriseBillingConfigResponse } from '@/api/generated'
import { listBillingConfigs } from '@/api/internal'
import {
  CreateBillingConfigDialog,
  EditBillingConfigDialog,
} from '@/pages/app/Enterprises/components/BillingConfigs/BillingConfigEditor'
import BillingConfigTable from '@/pages/app/Enterprises/components/BillingConfigs/BillingConfigTable'

const BILLING_CONFIGS_QUERY_KEY = ['billingConfigs'] as const

const BillingConfigs = () => {
  const [editingConfig, setEditingConfig] = useState<EnterpriseBillingConfigResponse | null>(null)
  const [isCreating, setIsCreating] = useState(false)

  const {
    data: configs = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: BILLING_CONFIGS_QUERY_KEY,
    queryFn: async () => {
      const response = await listBillingConfigs()
      return response.data.configs
    },
  })

  const handleSave = () => {
    setIsCreating(false)
    setEditingConfig(null)
  }

  return (
    <div className={styles.container}>
      {error && <div className={styles.errorBanner}>Failed to load billing configs</div>}

      <BillingConfigTable
        configs={configs}
        isLoading={isLoading}
        onEdit={(config: EnterpriseBillingConfigResponse) => setEditingConfig(config)}
        onCreate={() => setIsCreating(true)}
      />

      <CreateBillingConfigDialog isOpen={isCreating} onSave={handleSave} onCancel={() => setIsCreating(false)} />

      <EditBillingConfigDialog
        isOpen={!!editingConfig}
        config={editingConfig}
        onSave={handleSave}
        onCancel={() => setEditingConfig(null)}
      />
    </div>
  )
}

export default BillingConfigs
